// Fact card, in the shell's own markup. The cards themselves are the sim's
// (`edu/facts.ts`): bilingual text with a verified flag and its sources. This
// only draws one, and records it in the Encyclopedia on the way past.

import { t } from '../../i18n';
import { unlockFact } from '../../edu/facts';
import type { GameStateStore } from '../../core/store';
import { pick } from '../../i18n';
import { button, div, h } from '../dom';
import { chip } from './chip';
import type { FactCard } from '../../edu/facts';

export function factCard(
  fact: FactCard,
  store: GameStateStore,
  onClose?: () => void,
): HTMLElement {
  // Collecting the card is the Encyclopedia, and it happens whether the player
  // reads it or not — the tap is the reason it unlocked (EDUCATION-DESIGN §3).
  store.mutate((state) => {
    unlockFact(state, fact.id);
  });

  const card = div(
    { class: 'cf-fact', attrs: { role: 'dialog', 'aria-label': pick(fact.title) } },
    h('p', { class: 'cf-eyebrow', text: t('fact.category.' + fact.category) }),
    h('h2', { class: 'cf-title', text: pick(fact.title) }),
    h('p', { class: 'cf-sub', text: pick(fact.body) }),
    fact.sources
      ? h('p', { class: 'cf-fact__sources', text: t('fact.sources', { sources: fact.sources }) })
      : null,
    div(
      { class: 'cf-row cf-fact__foot' },
      chip({
        text: fact.verified ? t('fact.verified') : t('fact.draft'),
        tone: fact.verified ? 'good' : 'warn',
      }),
      h('span', { class: 'cf-grow' }),
      onClose
        ? button({
            class: 'cf-btn cf-btn--outline',
            text: t('common.close'),
            on: { click: onClose },
          })
        : null,
    ),
  );
  return card;
}
